import React from "react";

const eventOptions = [
    "http-request",
    "http-response",
    "frontend-log",
    "backend-log",
    "tecdoc-call",
    "database-write",
    "dashboard-usage",
];

const levelOptions = ["INFO", "WARN", "ERROR"];

export default function LogFilters({ filters, onChange, onSearch, onReset, isLoading }) {
    function handleChange(event) {
        const { name, value } = event.target;
        onChange({ ...filters, [name]: value });
    }

    return (
        <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
                <div>
                    <label className="block text-sm font-medium text-slate-600" htmlFor="correlationId">
                        Correlation ID
                    </label>
                    <input
                        id="correlationId"
                        name="correlationId"
                        value={filters.correlationId || ""}
                        onChange={handleChange}
                        className="mt-1 w-full rounded-md border border-slate-200 px-3 py-2 text-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                        placeholder="z. B. 3f1a..."
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-slate-600" htmlFor="event">
                        Event-Typ
                    </label>
                    <input
                        id="event"
                        name="event"
                        list="log-event-options"
                        value={filters.event || ""}
                        onChange={handleChange}
                        className="mt-1 w-full rounded-md border border-slate-200 px-3 py-2 text-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                        placeholder="z. B. http-response"
                    />
                    <datalist id="log-event-options">
                        {eventOptions.map((option) => (
                            <option key={option} value={option} />
                        ))}
                    </datalist>
                </div>
                <div>
                    <label className="block text-sm font-medium text-slate-600" htmlFor="level">
                        Log-Level
                    </label>
                    <select
                        id="level"
                        name="level"
                        value={filters.level || ""}
                        onChange={handleChange}
                        className="mt-1 w-full rounded-md border border-slate-200 px-3 py-2 text-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                    >
                        <option value="">Alle</option>
                        {levelOptions.map((option) => (
                            <option key={option} value={option}>
                                {option}
                            </option>
                        ))}
                    </select>
                </div>
                <div>
                    <label className="block text-sm font-medium text-slate-600" htmlFor="status">
                        HTTP-Status
                    </label>
                    <input
                        id="status"
                        name="status"
                        value={filters.status || ""}
                        onChange={handleChange}
                        className="mt-1 w-full rounded-md border border-slate-200 px-3 py-2 text-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                        placeholder="z. B. 500"
                    />
                </div>
            </div>
            <div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
                <div>
                    <label className="block text-sm font-medium text-slate-600" htmlFor="from">
                        Von
                    </label>
                    <input
                        type="datetime-local"
                        id="from"
                        name="from"
                        value={filters.from || ""}
                        onChange={handleChange}
                        className="mt-1 w-full rounded-md border border-slate-200 px-3 py-2 text-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-slate-600" htmlFor="to">
                        Bis
                    </label>
                    <input
                        type="datetime-local"
                        id="to"
                        name="to"
                        value={filters.to || ""}
                        onChange={handleChange}
                        className="mt-1 w-full rounded-md border border-slate-200 px-3 py-2 text-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                    />
                </div>
                <div className="md:col-span-2 lg:col-span-2 flex items-end justify-end gap-3">
                    <button
                        type="button"
                        onClick={onReset}
                        className="rounded-lg border border-slate-300 px-4 py-2 text-sm font-medium text-slate-600 hover:bg-slate-100"
                    >
                        Filter zurücksetzen
                    </button>
                    <button
                        type="button"
                        onClick={onSearch}
                        disabled={isLoading}
                        className="inline-flex items-center gap-2 rounded-lg bg-blue-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 disabled:cursor-not-allowed disabled:opacity-50"
                    >
                        {isLoading ? "Suche läuft..." : "Logs suchen"}
                    </button>
                </div>
            </div>
        </div>
    );
}
